import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const paymentTypeBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'directories',
    url: '/directories/stock'
  },
  {
    label: 'payment_type',
    active: true
  }
];

export type PaymentMethodType = {
  name: string;
  type: string;
  country: string;
  currency: string;
  status: string;
  guid: string;
};
